import { handleActions, combineActions } from 'redux-actions'

import * as activityActions from '../actions'
import * as galleryActions from '../../gallery/actions'
import * as defaultValues from '../common'

const defaultState = {
  activities: [],
  activitiesTake: defaultValues.ActivitiesTake,
  activitiesSkip: defaultValues.ActivitiesSkip,
  contentHeight: 0,
}

const _setActivitiesContentHeight = (state, contentHeight) => {
  return { ...state, contentHeight }
}

const _getActivitiesByContentIdSuccess = (state, payload) => {
  const activitiesSkip = state.activitiesSkip + state.activitiesTake
  return { ...state, activitiesSkip }
}

const _resetActivitiesSkipCount = (state, payload) => {
  const activitiesSkip = defaultValues.ActivitiesSkip
  return { ...state, activitiesSkip }
}

const _resetActivities = (state, payload) => {
  const activities = []
  return { ...state, activities }
}

function _delActivity(state, activityId) {
  const index = state.activities.findIndex((element) => element.id === activityId)

  let resultActivities = [...state.activities]
  if (index > -1) {
    resultActivities.splice(index, 1)
  }

  resultActivities = resultActivities.filter((item) => item.parentId !== activityId)

  return { ...state, activities: resultActivities }
}

function _sortActivity(state, payload) {
  const activities = payload.sort((a, b) => b.timestampCreated - a.timestampCreated)
  return { ...state, activities }
}

function _addActivity(state, activity) {
  const index = state.activities.findIndex((element) => element.id === activity.id)
  let result
  if (index === -1) {
    result = [...state.activities, activity]
  } else {
    result = [...state.activities]
    result[index] = activity
  }

  return _sortActivity(state, result)
}

function _addActivities(state, activities) {
  const newActivitiesMap = new Map()
  activities.forEach((activity) => newActivitiesMap.set(activity.id, activity))

  const result = state.activities.map((oldActivity) => {
    if (!newActivitiesMap.has(oldActivity.id)) {
      return { ...oldActivity }
    }

    const mergedActivity = { ...oldActivity, ...newActivitiesMap.get(oldActivity.id) }
    newActivitiesMap.delete(oldActivity.id)

    return mergedActivity
  })

  newActivitiesMap.forEach((activity) => {
    result.push(activity)
  })

  return _sortActivity(state, result)
}

function _delActivityByPageId(state, pageId) {
  const sourceActivities = [...state.activities]
  const activities = sourceActivities.filter((item) => item.pageId !== pageId)
  return { ...state, activities }
}

const activitiesList = handleActions(
  {
    [activityActions.cleanActivitiesList]() {
      return defaultState
    },
    [activityActions.setActivities](state, { payload }) {
      return _addActivities(state, payload)
    },
    [activityActions.addActivity](state, { payload }) {
      return _addActivity(state, payload)
    },
    [activityActions.updateActivity](state, { payload }) {
      return _addActivity(state, payload)
    },
    [activityActions.delActivity](state, { payload }) {
      return _delActivity(state, payload)
    },
    [combineActions(galleryActions.deleteGalleryItemSuccess, galleryActions.deleteGalleryItem)](state, { payload }) {
      return _delActivityByPageId(state, payload.pageId)
    },
    [activityActions.getActivitiesByContentIdSuccess](state, { payload }) {
      return _getActivitiesByContentIdSuccess(state, payload)
    },
    [activityActions.setActivitiesContentHeight](state, { payload }) {
      return _setActivitiesContentHeight(state, payload)
    },
    [activityActions.resetActivitiesSkipCount](state, action) {
      return _resetActivitiesSkipCount(state, action)
    },
    [activityActions.resetActivities](state, action) {
      return _resetActivities(state, action)
    },
    [activityActions.resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)

export default activitiesList
